
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { environment } from 'environments/environment';


@Injectable({providedIn: 'root'})
export class AuthService
{
    private _authenticated: boolean = false;
    private _httpClient = inject(HttpClient);
    private _userService = inject(UserService);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string)
    {

       // let tpm='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyVG9rZW4iOnsiZW1haWwiOiJpbmZvQGluZm9jb3JlLmNvbS5wZSIsInV1aWQiOiJQRzc0bXl6NGw5YTJ6WlN0MkplcUFJUmhrancxIn0sImlhdCI6MTcyNjQxNDU2NywiZXhwIjoxNzU3NTE4NTY3fQ.ViVQ4kbkOXXg5je_VxdsIN-YnVK15-3zGc1HFsVWlIk';
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string
    {
        return localStorage.getItem('accessToken') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any>
    {
        return this._httpClient.post('api/auth/forgot-password', email);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any>
    {
        return this._httpClient.post('api/auth/reset-password', password);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string ; metodo: string}): Observable<any> {
        // Crear FormData para enviar los credenciales

        
      
        const data = new FormData();
        data.append('action', 'login');
        data.append('email', credentials.email);
        data.append('pass', credentials.password);
        data.append('metodo	', credentials.metodo);
        data.append('tokenID', '03AFcWeA58JYyPN8s9W7-VIFwSY1vkgct5fDwQ2XmAQpFzyc-OqPYbTHAyaLiFtov20btg9VfCIq0XnBJjw6oKa8ELGloG3txX3j9qbHQBerQETFGoIaefAn_taYK0-OLUMZ18DQHxL8j_c0CITJlBsw68EIVELLMSSuUXfCoHhk3KFP06QNsOlQKx1F0ovQkTtUZKCVFaJsnzLg8anDCzN0k2If3EmpFLHZi84Ctg702vtI-ijIvySz8-cYyUSHIuBcRgNOKGqbzlwJDoDek95cmSqPmRRx0ClCf8TaCXoIvWyQ80JItO4uFLN9u5l16iUi2tK6uIpw0PgauB7jCYtHK0z28ZI6g26sdCMGNhdCkLAEFm4vnXuK2H-JH75QXnkdDkteO-gbXA22ZDbYqH0_KNuFAH5ei4WSmr5epHSfIdlwtknhPcyKr3e_fTO86Nk0tNFnC0XrA3Dj3-B_AUOyCHPtytuHBS8BrdkzAofsWHYPp3i0oGdtuaRSEX5BE3ofc2UHAqQ7N3U2rqieYmzjh4sNb7dQ0bY46FitlFz78XDQzrY3pDbFGmOQf4JjVp219nPGW0CK06BUqbIKYu2DOxjpI2YND_5Y43hX_JlSMu-BguQo9eq5fr1-VQqe4yjJiQnosImPioQC6zrQlrJ_UYtX1jVhq7dMfNBRrX7i9nXGTJfHFHncC1_770g_NsiDpHjgt_cjnKhhe_qXMt8nriS6S7Qad1wNWGIvZqu14Ek6gmGhddotjMU3Eqp58OvDxEE6M-3haFAmbe_I_YaM3fq84Bc5Jp9ddoaaGFoU09pTKCdx3a323uGC208AvoF0oHjygSGx6g0MEQ04MybN_HGhe6QN5vd1HTJoVPi6K2euzMH44ky-bstaBIxJZqNFq2dwj4M_3XnL97Yyq6z43zKZnuYKjS0ayZFzuLmpmwe75rA_RsltpE3KXeEa_M4gwEADdbSDMp70RW7q-quAUpYkmc69KuHGm8s7igXCe5CiYyb-hvGqWnFUn_tSDZhgDsY0b_g1xWJX6AXi3DiCy7XtB3qzXUj8tOmi4TUlpnTZ_XY-hw3WHTw0R0iWVo5nS7OyxznkYWtTJbiWAdx1w2KW6Jy5dOy6wjuB1Dxp5NT2zbIq8vB8b6UndZMOkwK9PO7mVfbqlwU9QdGiCkm4cf08oIjW_SVoP1bcOO-mR0pIAsdIAJQHm0NW2AulnDbWYAHgH8c-UUcc67lhWVAxZLbhmj1vFAP854BkOhzq0gvwHD-1BshpGN0tJp9ZeCjHKIcm7wXoXRGF9bl7SS9lIg9VM5HJoo0dvwfmcNqzyDyHX7j4qnToNDfyWfaiSYR7cXBWbNc1PA4sQKnuq-a4xrrPM7JllQ-MUuDg9McQk1XnHhDxfbs9TpHhnu0joZbGo0Sfgsvetq9MIqF6I8frn8PurMklVWR8MiLbOnvqp_EUldoT2D1JaNwtWmzcXXZfh_4q5zpydd7Hmp8uZNV1bB9fEzz5xydR365bf_-Un-QN7Ms4DguqxuCHlpPrXzjIxviBmUEg4xza3kQ-YAoUqlo2XGY2fB0Hzc_qyAR_ylOiF2tty_gjPkWsnhKj1E7KBjYwGCfZSH9TNy6wpMBxpqYoDDX2Hisr7_TMS8IgU_ON1LV7hKXj-Z0NXQdeQ9lAFOxiXSd95VSYVYvR3P7-6ZBqPsvYxUKJjG21RAp90TpVzgtQq0K-4DEzn2RxkWFA2guMSfkN4X7D2XzE6gyCVquHl_0DeDhUbeWS8ch3rL47_jAu1Nne98QdiOHdp3Dpp_fidf6HKh7lL_BSTSRaZ3iUxvjDKIbIErYO5z2JTBtBu_64xlqFLlujgo1FxhZjT3vKfm9x56Lt1FpGypy1UgQl-qzfuMWw');
    
        const body = {
     
            email: credentials.email,
            password: credentials.password,
            rememberMe: ''
     
        }

        localStorage.setItem('email',  credentials.email);
        // Hacer la solicitud POST
        return this._httpClient.post<any>(environment.path4 + '/api/signin', body, {
            reportProgress: true,
            observe: 'response'
        }).pipe(
            switchMap((response: any) => {
                const body = response.body;
    

                console.log(body);
                // Verificar si la respuesta contiene un token en stringAlternativo

               
                if (body && body.accessToken) {
                    // Guardar el token en el localStorage
                    this.accessToken = body.accessToken;
                    console.log("ingreso");

                    localStorage.setItem('token',  this.accessToken);
                    //     this.uuid=response.user.id;
                    localStorage.setItem('id',  body.user.id);
                  
    
                    // Configurar la autenticación como verdadera
                    this._authenticated = true;
    
                 
                    let userTmp = {
                        id: body.user.id,
                        permiso: "superadmin",
                        name: "info",
                        email: credentials.email,
                        ruc: "20601019869",
                        avatar: "assets/images/avatars/brian-hughes.jpg",
                        status: "ok"
                    };

    
                    this._userService.user = userTmp;


                    // Devolver la respuesta completa o true
                    return of(body);
                } else {
                    this._authenticated = false;
                    // Devolver un error si no se encuentra el token
                    return throwError(() => new Error('Error en el inicio de sesión: token no recibido.'));
                }
            }),
            catchError((error) => {
                // Manejo de errores
                return throwError(() => new Error('Error en el inicio de sesión: ' + error.message));
            })
        );
    }


    verifyMFA(code) {

        const email = localStorage.getItem('email');
  
        return this._httpClient.post(environment.path3 + '/usuario/validarCodigoLogeo',
          {
            code: Number(code), // Asegura que sea tipo number
            'email':email
          },
          this.ngGetHeaderV2());
      }

      ngGetHeaderV2() {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('token2') || '""'
          })
        };
    
        return httpOptions;
      }
      
    

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any>
    {
        // Sign in using the token
        return this._httpClient.post('api/auth/sign-in-with-token', {
            accessToken: this.accessToken,
        }).pipe(
            catchError(() =>

                // Return false
                of(false),
            ),
            switchMap((response: any) =>
            {
                // Replace the access token with the new one if it's available on
                // the response object.
                //
                // This is an added optional step for better security. Once you sign
                // in using the token, you should generate a new one on the server
                // side and attach it to the response object. Then the following
                // piece of code can replace the token with the refreshed one.
                if ( response.accessToken )
                {
                    this.accessToken = response.accessToken;
                }

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return true
                return of(true);
            }),
        );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any>
    {
        // Remove the access token from the local storage
        localStorage.removeItem('accessToken');

        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { name: string; email: string; password: string; company: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean>
    {
        // Check if the user is logged in
        if ( this._authenticated )
        {
            return of(true);
        }

        // Check the access token availability
        if ( !this.accessToken )
        {
            return of(false);
        }

        // Check the access token expire date
        if ( AuthUtils.isTokenExpired(this.accessToken) )
        {
            return of(false);
        }

        // If the access token exists, and it didn't expire, sign in using it
        return this.signInUsingToken();
    }

    loginWithGoogle(idToken: string): Observable<any> {
        return this._httpClient.post('https://apii-invitaaqui-dot-lavafast-d4a16.uc.r.appspot.com/api/login/google', { idToken });
      }
}
